import './App.css';
import SinglePageLayout from './layouts/SinglePageLayout';

function App() {
  return (
    <SinglePageLayout />
  )
}

export default App;
